import React, { Component } from "react";
import { Modal } from "antd";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../../../../../services/settings";
import { Icon } from "semantic-ui-react";
import bid from "../../../../../assets/images/bid.png";
import {
  renderData,
  renderRefreshText,
  customStyles,
} from "../../../../common/CommonMethods";
import NumberFormat from "react-number-format";

class Deals180 extends Component {
  constructor(props) {
    super(props);
  }

  onView = (id) => {
    const { isEnitityExist, history, dealAccessDenialMessage } = this.props;

    if (isEnitityExist) {
      this.props.history.push(`/user/deal-view/${id}`);
    } else {
      Modal.confirm({
        // title: "Confirm",
        width: 600,
        okButtonProps: {
          type: "primary",
          size: "large",
        },
        cancelButtonProps: {
          size: "large",
        },
        // icon: <ExclamationCircleOutlined />,

        content: <p className="pconfirm">{dealAccessDenialMessage}</p>,
        okText: "My Profile",
        cancelText: "Cancel",
        onOk() {
          history.push("/user/profile");
        },
        onCancel() {},
      });
    }
  };

  handleChange = (row) => {
    const { isEnitityExist, history, dealAccessDenialMessage } = this.props;
    if (isEnitityExist) {
      this.props.history.push(`/user/deal-view/${row.uuid}`);
    } else {
      Modal.confirm({
        width: 600,
        okButtonProps: {
          type: "primary",
          size: "large",
        },
        cancelButtonProps: {
          size: "large",
        },
        // title: "Confirm",
        // icon: <ExclamationCircleOutlined />,
        content: <p className="pconfirm">{dealAccessDenialMessage}</p>,
        okText: "My Profile",
        cancelText: "Cancel",
        onOk() {
          history.push("/user/profile");
        },
        onCancel() {},
      });
    }
  };

  render() {
    const { loading } = this.props;

    const columns = [
      {
        name: "",
        selector: "picture",
        sortable: false,
        className: "company no-wrap",
        // style: { minWidth: "120px" },
        cell: (row) => (
          <>
            <div
              className="company-logo"
              onClick={() => this.handleChange(row)}
            >
              {row.picture && (
                <img
                  style={{
                    maxWidth: "70px",
                    maxHeight: "70px",
                    float: "left",
                  }}
                  src={`${BaseUrl}/storage/${row.picture.id}/${row.picture.file_name}`}
                  alt=""
                />
              )}
            </div>
          </>
        ),
      },
      {
        name: "Instrument",
        selector: "instrument",
        sortable: false,
        className: "company wrap",
        cell: (row) => (
          <>
            <div className="wrap" onClick={() => this.handleChange(row)}>
              <span>{row.instrument}</span>
            </div>
          </>
        ),
      },
      {
        name: "Sector",
        selector: "sector",
        sortable: false,
        className: "company wrap",
        cell: (row) => (
          <>
            <div className="wrap" onClick={() => this.handleChange(row)}>
              <span>{row.sector}</span>
            </div>
          </>
        ),
      },
      {
        name: "Location",
        selector: "location",
        sortable: false,
        className: "company wrap",
        cell: (row) => (
          <>
            <div className="wrap" onClick={() => this.handleChange(row)}>
              <span>{row.geography}</span>
            </div>
          </>
        ),
      },
      {
        name: "Raise Amount",
        selector: "offer",
        sortable: false,
        className: "company wrap",
        cell: (row) => (
          <>
            <div className="wrap" onClick={() => this.handleChange(row)}>
              <span>
                <NumberFormat
                  value={row.offer}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </span>
            </div>
          </>
        ),
      },
      // {
      //   name: "Estimated Exit Date",
      //   selector: "estimate_exit_date",
      //   sortable: false,
      //   className: "company wrap",
      //   cell: (row) => (
      //     <>
      //       <div className="wrap" onClick={() => this.handleChange(row)}>
      //         <span>{row.estimate_exit_date}</span>
      //       </div>
      //     </>
      //   ),
      // },
      {
        name: "Internal Rate of Return (IRR)",
        selector: "internal_return_rate",
        sortable: false,
        className: "company wrap",
        cell: (row) => (
          <>
            <div className="wrap" onClick={() => this.handleChange(row)}>
              <span>
                {row.internal_return_rate ? `${row.internal_return_rate}` : ""}
              </span>
            </div>
          </>
        ),
      },
      // {
      //   name: "Est. Rate of Return",
      //   selector: "estimate_return",
      //   sortable: false,
      //   className: "company wrap",
      //   cell: (row) => (
      //     <>
      //       <div className="wrap" onClick={() => this.handleChange(row)}>
      //         <span>{row.estimate_return ? `${row.estimate_return}` : ""}</span>
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   name: "Min Bid",
      //   selector: "min_bid",
      //   left: true,
      //   cell: (row) => (
      //     <>
      //       <div className="wrap" onClick={() => this.handleChange(row)}>
      //         <span>
      //           <NumberFormat
      //             value={row.min_bid}
      //             displayType={"text"}
      //             thousandSeparator={true}
      //             prefix={"$"}
      //           />
      //         </span>
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   name: "Current Yield",
      //   selector: "current_yield",
      //   left: true,
      //   cell: (row) => (
      //     <>
      //       <div className="wrap" onClick={() => this.handleChange(row)}>
      //         <span>{row.current_yield}</span>
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   name: "Loan to Value",
      //   selector: "loan_to_value",
      //   left: true,
      //   cell: (row) => (
      //     <>
      //       <div className="wrap" onClick={() => this.handleChange(row)}>
      //         <span>{row.loan_to_value}</span>
      //       </div>
      //     </>
      //   ),
      // },
      {
        name: "Deal View",
        selector: "bid_now",
        left: true,
        cell: (row) => (
          <div className="tbl-title" onClick={() => this.onView(row.uuid)}>
            <span className="bid-now">
              <Icon
                style={{ cursor: "pointer" }}
                color="blue"
                size="huge"
                name="arrow alternate circle right outline"
              />
              <span className="ico"></span>
            </span>
          </div>
        ),
      },

      {
        name: "Bid Now",
        selector: "bid_now",
        left: true,
        cell: (row) => (
          <div className="tbl-title bidnow-title">
            {row.status === "Finished" ? (
              "This Placement has closed"
            ) : (
              <img
                src={bid}
                style={{ cursor: "pointer", width: "38px" }}
                onClick={() => this.props.onBidNow(row.uuid)}
              />
            )}
          </div>
        ),
      },
    ];

    return (
      <div className="md-table-normal">
        {!loading &&
        this.props.deals &&
        this.props.deals !== undefined &&
        this.props.deals.length === 0 ? (
          <div className="p-4">Standby! More great deals are on their way!</div>
        ) : (
          <DataTable
            noHeader
            overflowY
            highlightOnHover
            responsive={true}
            columns={columns}
            data={this.props.deals}
            style={{ width: "100%" }}
            onRowClicked={this.handleChange}
            pointerOnHover={true}
            sortServer={true}
            noDataComponent={<div className="p-4">Loading...</div>}
            customStyles={customStyles}
          />
        )}
      </div>
    );
  }
}
export default Deals180;
